<template>
  <el-dialog
    :visible.sync="showDialog"
    :width="modalWidth"
    top="30vh"
    :before-close="handleClose"
    :show-close="false"
  >
    <main class="flex flex-col items-center relative">
      <span @click="handleClose" class="cursor-pointer absolute -top-8 right-0">
        <close-icon size="h-5 w-5" />
      </span>
      <h3 class="text-lg text-black-10 font-semibold">Remove Beneficiary</h3>
      <p class="text-center text-xs my-5 lg:text-sm font-normal text-gray-25">
        Are you sure you want to remove this Beneficiary?
      </p>

      <div class="flex items-center gap-4 mt-5">
        <button @click="handleClose" class="bg-gray-26 shadow-md text-black-10">
          No
        </button>
        <button @click="handleRemove" class="bg-primary text-white">Yes</button>
      </div>
    </main>
  </el-dialog>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'

export default {
  name: 'RemoveBeneficiary',
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  components: {
    CloseIcon: () => import('@/assets/v2/icons/CloseIcon')
  },
  data () {
    return {
      breakpoints
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '30%' : breakpoints.mdAndUp ? '70%' : '80%'
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDialog')
    },
    handleRemove () {
      this.$emit('removeBeneficiary')
    }
  }
}
</script>

<style scoped>
button {
  padding: 15px 60px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;

  &:hover {
    opacity: 0.8;
  }
}

>>> .el-dialog {
  border-radius: 8px !important;
}
>>> .el-dialog__body {
  padding: 20px;
}
</style>
